import ExpandableContent from './ExpandableContent';

export default ExpandableContent;
